import { memo, useEffect, useState } from 'react';
import { BzButton, BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzModalTitle } from "../../components";
import { Container, Row, Col } from "react-bootstrap";
import { useSelector } from 'react-redux';
import { DONT_MISS_WATCHLIST_NAME, MY_HOLDINGS_WATCHLIST_NAME } from '../../utils/global_variables';




const RenameModal = ({ show, cancelModal, renamedWatchlistName, handleChange, onRenameWatchlist, activeWatchList, ...props }) => {


    const { globalWatchlists, selectedWatchlist, watchlists } = useSelector(state => state.watchList);


    //Ameersha N : Breeze BT-98555 Create Watchlist feature --Start
    const [isButtonEnabled, setIsButtonEnabled] = useState(true);
    useEffect(() => {
        //while any renaming Watchlist to stop allowing of top picks watchlist Rename this was used
        let objExistingWatchlist = globalWatchlists?.length ? globalWatchlists?.find((each) => each?.sWatchListName?.toLowerCase() === renamedWatchlistName?.toLowerCase()) : false;
        let existingWatlist = watchlists?.length ? watchlists?.find((each) => each?.sWatchListName?.toLowerCase() === renamedWatchlistName?.toLowerCase()) : false;

        if (objExistingWatchlist || existingWatlist || renamedWatchlistName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME || renamedWatchlistName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME) {
            setIsButtonEnabled(false);
        } else {
            setIsButtonEnabled(true);
        }
    }, [globalWatchlists, watchlists, renamedWatchlistName]);
    //Ameersha N : Breeze BT-98555 Create Watchlist feature --End

    return (
        <BzModal size="sm" show={show} onHide={cancelModal} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <BzModalTitle className='font-medium font-size4 color-text'>Rename Watchlist</BzModalTitle>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={cancelModal}>&nbsp;</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        {Object.keys(activeWatchList)?.length > 0 &&
                            <Row className='g-0 mb-4'>
                                <Col className='d-flex justify-content-start'>
                                    {Object.keys(activeWatchList)?.length > 0 &&
                                        <>
                                            <div className='font-regular font-size3 color-text'>Current Watchlist name: <span className='font-medium font-size3 color-text ms-1'>'{activeWatchList?.sWatchListName} ({activeWatchList?.scrips?.length})'</span></div>
                                        </>}
                                </Col>
                            </Row>
                        }
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size4 color-text'>Rename Watchlist to:</div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-2'>
                            <Col className='d-flex justify-content-start'>
                                <div className='input-group'>
                                    <BzInputText size='sm' autoFocus maxLength='20' value={renamedWatchlistName?.toUpperCase()} onChange={(e) => handleChange(e)} className='font-regular form-control' placeholder='Enter new name here' />
                                </div>
                            </Col>
                        </Row>
                        {(!isButtonEnabled && renamedWatchlistName?.length > 0 && selectedWatchlist?.sWtachlistType === "static") &&
                            <div className='error-msg'>Watchlist name already exist</div>
                        }

                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0 justify-content-end'>
                            <Col md={4} className='d-flex align-items-center'>
                                <BzButton className='btn btn-md btn-block btn-primary' disabled={isButtonEnabled ? false : true} onClick={() => onRenameWatchlist(renamedWatchlistName)}>Rename</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </form>
        </BzModal>
    );
};

export default memo(RenameModal);
